module.exports = __webpack_public_path__ + "public/img/guanzhu.b4d263f8.png";